const FourOhFour = () => import( /* webpackChunkName: "error" */ './404');

export default [{
    path: '/404',
    component: FourOhFour,
    name: '404',
  },
  { path: '*', redirect: '/404' },
];